webpackJsonp([75],{

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1280);


/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(179);

var _datetime2 = _interopRequireDefault(_datetime);

var _it = __webpack_require__(795);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('it', _it2.default);

/***/ })

},[1279]);


// WEBPACK FOOTER //
// app/datetime.it-36d4562532b48f0c394c.js